module.exports = {
    "getboarded": ["prestige", "greyline"],
    "gala": ["lightcharactercard", "darkcharactercard"]
};